export const sxStyle = {
  siteContainer: {
    zoom: '111.12%',
    minHeight: '100vh',
  },
  headerContainer: {
    zoom: '90%',
  },
  containerCompany: {
    width: '80%',
    margin: '4% auto 6% auto',
    padding: '30px 30px 50px 30px',
    boxShadow: '1px 3px 9px 3px rgba(0, 0, 0, 0.15)',
  },
  title: {
    color: 'black',
    fontSize: '25px',
    marginTop: '0.5rem',
    marginBottom: '0.1rem',
  },
  subTitle: {
    color: 'black',
    fontSize: '20px',
    marginTop: '1.1rem',
    marginBottom: '0.9rem',
  },
  containerFooter: {
    marginTop: 'auto',
    backgroundColor: '#F6F6F6',
    zoom: '90%',
  },
  allContainers: {
    justifyContent: 'space-between',
  },
  container1: {
    width: { xs: '100%', sm: '49%' },
    textAlign: 'justify',
  },
  container2: {
    width: { xs: '100%', sm: '49%' },
    textAlign: 'justify',
  },
  p: {
    fontSize: '15px',
    marginBottom: '10px',
  },
};
